import React, { lazy } from "react";
import Loadable from "../components/Loadable";
// import { authRoles } from "../auth/authRoles";
import { routeCheck } from "app/data/roles";

// const UserProfileSettins = Loadable(lazy(() => import('app/views/profile/UserProfileSettings')));
const UsersList = Loadable(lazy(() => import('app/views/users/UsersList')))

const usersPaths = routeCheck(
    [ 
       { path: "/users/list", element: <UsersList/> },
    ], 
    false 
)

export default usersPaths;